import { render, staticRenderFns } from "./LoginModeratorMask.vue?vue&type=template&id=7a6ca2ca&"
import script from "./LoginModeratorMask.vue?vue&type=script&lang=ts&"
export * from "./LoginModeratorMask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports